<template>
  <div :class="['spacer', cssClass]" />
</template>

<script>
export default {
  name: 'Spacer',
  props: {
    span: {
      default: 8,
      type: Number,
      validator(val) {
        return [4, 8, 16, 24, 32, 40].includes(val)
      }
    }
  },
  computed: {
    cssClass() {
      return 'space-' + this.span
    }
  }
}
</script>

<style lang="scss" scoped>
  $spaces: (4, 8, 16, 24, 32, 40);

  .spacer {
    height: 8px;
    clear: both;
  }

  @each $i in $spaces {
    .space-#{$i} {
        height: #{$i}px;
    }
  }
</style>
